import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {

    constructor(private translateService: TranslateService, private toastService: ToastService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            tap((event) => {
                if (event instanceof HttpResponse && event.body.errors) {
                    const errors = event.body.errors;
                    if (errors.length > 0) {
                        const foundError = errors.find(e => e.extensions && e.extensions.classification === 'custom');
                        if (foundError && foundError.message && foundError.message !== 'error.entity.notfound') {
                            const {classification, ...params} = foundError.extensions ?? {};
                            const errorMsg = this.translateService.instant(foundError.message, params);
                            this.toastService.showErrorToast(errorMsg).subscribe();
                        }
                    }
                }
            })
        );
    }
}
